import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "form-custom mt-2" }
const _hoisted_2 = { class: "details-panel-content-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "p-field mb-4"
}
const _hoisted_4 = { class: "fw-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ListItemCheck = _resolveComponent("ListItemCheck")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.gates.length > 0)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("AppResourceEP.SelectTheGatesWhereEnableTheAccess")), 1),
            _createVNode(_component_ElScrollbar, { class: "details-panel-content gate-list mt-3" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.gates, (g, gateIdx) => {
                  return (_openBlock(), _createBlock(_component_ListItemCheck, {
                    key: g.gateId,
                    label: g.name,
                    value: g.gateId,
                    modelValue: _ctx.apartmentGates,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.apartmentGates = $event)),
                    name: "specificGate",
                    inputId: 'specificg' + gateIdx,
                    last: gateIdx == _ctx.currentEntrancePlantGatesCount - 1,
                    disabled: _ctx.disabled
                  }, null, 8, ["label", "value", "modelValue", "inputId", "last", "disabled"]))
                }), 128))
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", null, [
        _createVNode(_component_ListItemCheck, {
          disabled: _ctx.disabled,
          value: _ctx.applyToAllTheResidents,
          name: "applyToAllTheResidents",
          inputId: "applyToAllTheResidentsCheckbox",
          modelValue: _ctx.apartmentGates,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.apartmentGates = $event)),
          label: _ctx.$t('AppResourceEP.ApplyToAllTheResidents')
        }, null, 8, ["disabled", "value", "modelValue", "label"])
      ])
    ])
  ]))
}